/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Settings_SaveInputs */

const vi_smartlab_irrigation_settings_save = /** @type {(inputs: Smartlab_Irrigation_Settings_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu phun nước`)
};

/**

* @param {Smartlab_Irrigation_Settings_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_settings_save = /** @type {((inputs?: Smartlab_Irrigation_Settings_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Settings_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_settings_save(inputs)
});